import api from "../config/api";
import { RoleMaster } from "../redux/actions/authUserActions";

const API_URL = "/roles";
export const createRole = (data: RoleMaster) =>
  api.post(`${API_URL}/`, data, {
    headers: {
      "Content-Type": "application/json",
    },
  });

export const getRoles = () =>
  api.get(`${API_URL}/`).then((res) => res.data.data);

export const getRoleById = (id: number) => api.get(`${API_URL}/${id}`);

export const updateRole = (id: number, data: RoleMaster) =>
  api.put(`${API_URL}/${id}`, data);

export const deleteRole = (id: number) => api.delete(`${API_URL}/${id}`);
